import { Outlet } from 'react-router'

export default function ShopLayout() {
	return <Outlet />
}
